export default "__VITE_PUBLIC_ASSET__d22d2f51__"